import { useEffect, useMemo, useState } from 'react';
import { useAuth, useSession } from '@ev-tech/user-account-modules';

export type UserData = {
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
};
export const useUserData = () => {
  const { session } = useSession();
  const { isSignedIn } = useAuth();
  const [userData, setUserData] = useState<UserData>();

  const isSignedInAndUserDataNotLoaded = useMemo(() => isSignedIn && !userData, [isSignedIn, userData]);

  useEffect(() => {
    if (!session?.user) {
      setUserData(undefined);
      return;
    }

    setUserData({
      email: session.user.primaryEmailAddress?.emailAddress,
      firstName: session.user.firstName ?? undefined,
      lastName: session.user.lastName ?? undefined,
      phoneNumber: session.user.phoneNumbers[0]?.phoneNumber,
    });
  }, [session?.user]);

  return { userData, isSignedInAndUserDataNotLoaded };
};
